import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    EMAIL: '',
    NAME: 'UNKNOWN',
    PROFILE: '',
    MOBILE: '',
    LONGTERM: 0,
    TOKEN: '',
    REFRESH_TOKEN: '',
    AUTH: -1,
    UPDATED: 0,
    SUBMITTED: 0,
    APISERVER: '',
    AUTHLIST: {},
    PRINTID: '',
    PRINTLONGTERM: 0
  },
  getters: {
    isRemnant: state => {
      return state.AUTH < 0
    },
    isPartAuth: state => {
      return state.AUTH > 0
    },
    isSuper: state => {
      return state.AUTH === 0
    },
    isRealSuper: state => {
      return state.AUTH === 0 && state.EMAIL === 'super@adm.in'
    },
    isReader: state => {
      return state.AUTH === 11 // 읽기모드
    },
    authName: state => {
      let name = '렘넌트'
      Object.keys(state.AUTHLIST).forEach(key => {
        if (state.AUTHLIST[key] === state.AUTH) {
          name = key
        }
      })
      return name
    },
    authNameVal: state => (auth) => {
      let name = '렘넌트'
      Object.keys(state.AUTHLIST).forEach(key => {
        if (state.AUTHLIST[key] === auth) {
          name = key
        }
      })
      return name
    },
    profile: state => {
      if (state.NAME === 'UNKNOWN') {
        return ''
      }
      return state.APISERVER + '/cdn/img?id=' + state.PROFILE + '&email=' + state.EMAIL
    }
  },
  mutations: {
    setAuthList (state, list) {
      state.AUTHLIST = Object.assign({}, list)
    },
    setApiServer (state, apiServer) {
      state.APISERVER = apiServer
    },
    setEmail (state, email) {
      state.EMAIL = email
    },
    setToken (state, tok) {
      state.TOKEN = tok
    },
    resetToken (state) {
      state.TOKEN = ''
    },
    setRefreshToken (state, retok) {
      state.REFRESH_TOKEN = retok
    },
    setAuth (state, auth) {
      state.AUTH = auth
    },
    setName (state, name) {
      state.NAME = name
    },
    setProfile (state, profile) {
      state.PROFILE = profile
    },
    setUpdated (state, val) {
      state.UPDATED = val
    },
    setMobile (state, mobile) {
      state.MOBILE = mobile
    },
    setLongterm (state, val) {
      state.LONGTERM = val
    },
    setSubmit (state, val) {
      state.SUBMITTED = val
    },
    setPrintId (state, val) {
      state.PRINTID = val
    },
    setPrintLongterm (state, val) {
      state.PRINTLONGTERM = val
    },
    clearAll (state) {
      state.EMAIL = ''
      state.NAME = 'UNKNOWN'
      state.PROFILE = ''
      state.MOBILE = ''
      state.LONGTERM = 0
      state.TOKEN = ''
      state.REFRESH_TOKEN = ''
      state.AUTH = -1
      state.UPDATED = 0
      state.SUBMITTED = 0
      state.PRINTID = ''
    }
  },
  actions: {

  }
})
